$(function() {
	$('.triggerspinner').click(function(){
		$('#overlay').fadeIn();
	});
});

